import { IVec3 } from "@faro-lotv/ielement-types";

/**
 * Get the coordinates string "x, y, z" in Z-up for a given point in ProjectAPI-Y-up
 *
 * @param point the given coordinate in Y-up
 * @returns a point of the coordinates in Z-up.
 */
export function getCoordinateZUp(point: IVec3): IVec3 {
  return { x: point.x, y: point.z, z: point.y };
}
